










import { Component, Vue, Prop } from 'vue-property-decorator';
import { OptionSelectorOption } from '@/models/common/OptionSelectorOption';

@Component({})
export default class OptionSelector extends Vue {
  @Prop({ type: [Number, Array] }) public value!: number | number[];
  @Prop({ type: Array, default: (): OptionSelectorOption[] => [] }) public options!: OptionSelectorOption[];

  isOptionSelected(id: number){
    if(Array.isArray(this.value)){
      return this.value.indexOf(id) >= 0;
    }

    return this.value === id;
  }

  onOptionSelected(id: number){
    if(Array.isArray(this.value)){
      if(this.value == null){
        this.$emit("input", [id]);
      } else if(this.isOptionSelected(id)){
        this.$emit("input", this.value.filter(x => x !== id));
      } else {
        this.$emit("input", this.value.concat([id]));
      }
    } else {
      this.$emit("input", id);
    }
  }
}

